import _get from 'lodash.get';
import { getValidCWVReportingActiveConfigs } from '../components/Html/utilities/utils';

const getCwvReportingObj = (info = {}) => {
  const {
    state, // page state
    dataAvailable, // data
    platform,
    browsingPlatform,
    businessProperty,
    pageName,
  } = info;
  if (dataAvailable) {
    const { subsec1: { seolocation1 = '' } = {} } =
      dataAvailable.navsubsecs || {};

    const CWVReportingActiveConfigs =
      getValidCWVReportingActiveConfigs(
        _get(state, `common.siteConfig.CWVReporting`),
        {
          pageName,
          platform,
          sectionName: seolocation1.toLowerCase(),
        },
      ) || {};

    let { userPercentage, grxUserPercentage } = CWVReportingActiveConfigs;

    if (
      CWVReportingActiveConfigs.sectionWiseUserPercent &&
      Array.isArray(CWVReportingActiveConfigs.sectionWiseUserPercent)
    ) {
      const sectionUserPercent = CWVReportingActiveConfigs.sectionWiseUserPercent.find(
        userPercObj =>
          userPercObj?.section?.toLowerCase() === seolocation1.toLowerCase(),
      );
      userPercentage = sectionUserPercent?.userPercent || userPercentage;
      grxUserPercentage = sectionUserPercent?.grxUserPercent || grxUserPercentage;
    } else if (
      CWVReportingActiveConfigs.sectionWiseUserPercent &&
      typeof CWVReportingActiveConfigs.sectionWiseUserPercent === 'object'
    ) {
      // this check is added as data coming from xslt site_setting temlate return object if array has 1 item only
      userPercentage =
        CWVReportingActiveConfigs.sectionWiseUserPercent.section?.toLowerCase() ===
        seolocation1.toLowerCase()
          ? CWVReportingActiveConfigs.sectionWiseUserPercent.userPercent
          : userPercentage;
      grxUserPercentage =
        CWVReportingActiveConfigs.sectionWiseUserPercent.section?.toLowerCase() ===
        seolocation1.toLowerCase()
          ? CWVReportingActiveConfigs.sectionWiseUserPercent.grxUserPercent
          : grxUserPercentage;
    }
    return {
      ...CWVReportingActiveConfigs,
      userPercentage,
      grxUserPercentage,
      section: (
        _get(dataAvailable.navsubsecs, 'subsec1.subsecname1') || ''
      ).toLowerCase(),
      subsection: (
        _get(dataAvailable.navsubsecs, 'subsec2.subsecname2') || ''
      ).toLowerCase(),
      browsing_platform: browsingPlatform,
      page_template: pageName,
      business_property: businessProperty,
      js: CWVReportingActiveConfigs?.js || {},
      loadJsAt:
        CWVReportingActiveConfigs?.js?.loadJsAt === 'head' ? 'head' : 'body',
    };
  }
  return undefined;
};

export default getCwvReportingObj;
